import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Tabs, Tab, Alert } from 'react-bootstrap';
import Form from '../form/Form';
import FieldGroup from '../field_group/FieldGroup';
import ChillerDataTable from './ChillerDataTable';
import WaterPumpDataTable from './WaterPumpDataTable';
import CoolingTowerDataTable from './CoolingTowerDataTable';
import AirHandlingUnitDataTable from './AirHandlingUnitDataTable';
import { requiredValidator } from '../field_group/validators';
import { getErrorValue, stringifyErrorMessage } from '../../utils/utility';

export class ACCentralDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;

    this.state = {
      tabActiveKey: 1,
    };
  }

  getACData() {
    return this.formRef.getFormData();
  }

  renderOption(item, prefix) {
    const { t } = this.props;
    return (
      <option key={prefix ? `${prefix}${item.id}` : item.id} value={item.id}>
        {t(String(item.name).toLowerCase())}
      </option>
    );
  }

  renderBasicInfo() {
    const {
      name,
      number_of_equipments,
      description,
      image,
    } = this.props.ac;

    const { disabled, fieldErrors, errorMessage, t, ...otherAttr } = this.props;
    const customAttr = { disabled };

    return (
      <Form image={image} {...otherAttr} ref={ref => (this.formRef = ref)}>
        <FieldGroup
          id="air-conditioning-central-unit-name"
          field="name"
          type="text"
          label={t('name')}
          placeholder={t('a/c central name')}
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <FieldGroup
          id="air-conditioning-central-unit-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          {...customAttr}
        />
      </Form>
    );
  }

  renderChiller() {
    const {
      t,
      ac: {id, chiller_list },
    } = this.props;

    return (
      <Tab eventKey={2} title={t('chiller')}>
        <ChillerDataTable
          acCentralId={id}
          chillers={chiller_list}
          mode={this.props.mode}
          onEditItem={item => this.setState({ selectedItem: item })}
        />
      </Tab>
    );
  }

  renderWaterPump() {
    const {
      t,
      ac: { id, water_pump_list },
    } = this.props;

    return (
      <Tab eventKey={3} title={t('water pump')}>
        <WaterPumpDataTable
          acCentralId={id}
          waterPumps={water_pump_list}
          mode={this.props.mode}
          onEditItem={item => this.setState({ selectedItem: item })}
        />
      </Tab>
    );
  }

  renderCoolingTower() {
    const {
      t,
      ac: { id, cooling_tower_list },
    } = this.props;

    return (
      <Tab eventKey={4} title={t('cooling tower')}>
        <CoolingTowerDataTable
          acCentralId={id}
          mode={this.props.mode}
          coolingTowers={cooling_tower_list}
          onEditItem={item => this.setState({ selectedItem: item })}
        />
      </Tab>
    );
  }

  renderAirHandlingUnit() {

    const {
      t,
      ac: { id, fan_coil_list },
    } = this.props;

    return (
      <Tab eventKey={5} title={t('air handling unit')}>
        <AirHandlingUnitDataTable
          acCentralId={id}
          mode={this.props.mode}
          ahus={fan_coil_list}
          onEditItem={item => this.setState({ selectedItem: item })}
        />
      </Tab>
    );
  }

  renderErrorMessage(errorMessage) {
    if (!errorMessage) return null;
    return (
      <Alert
        bsStyle="danger"
        style={{ 'white-space': 'pre' }}
      >
        {errorMessage}
      </Alert>
    );
  }

  render() {
    const { t, ac, errorMessage } = this.props;
    const { tabActiveKey } = this.state;
    const detailError = stringifyErrorMessage(errorMessage);
    return (
      <React.Fragment>
        {detailError ? this.renderErrorMessage(detailError) : null}
        <Tabs
          id="ac-tabs"
          activeKey={tabActiveKey}
          onSelect={key => this.setState({ tabActiveKey: key })}
        >
          <Tab
            eventKey={1}
            title={t('basic info')}
          >
            {this.renderBasicInfo()}
          </Tab>
          {this.renderChiller()}
          {this.renderWaterPump()}
          {this.renderCoolingTower()}
          {this.renderAirHandlingUnit()}
        </Tabs>
      </React.Fragment>
    );
  }
}

ACCentralDetail.defaultProps = {
  ac: {},
};

const mapStateToProps = state => ({
  isEditing: state.ac.central.isEditing,
  errorMessage: state.ac.central.errorMessage,
});

const mapDispatchToProps = dispatch => ({
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(ACCentralDetail),
);



// WEBPACK FOOTER //
// ./src/components/ac_central/ACCentralDetail.js